import React from 'react';
import { Box, Typography } from '@mui/material';

const NotFound = () => {

    document.title = `Not Found - Wotagei Zone`

    return (
        <Box 
            sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100vh', 
            textAlign: 'center' 
            }}
        >
            <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 'bold' }}>
            404
            </Typography>
            <Typography variant="h5" sx={{ mb: 2 }}>
            Oops! Page not found.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
            The page you are looking for does not exist.
            </Typography>
        </Box>
    );
};

export default NotFound;